import { Link2 } from "lucide-react";
import { toast } from "sonner";
import { SocialShare } from "./Social";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4C2.7 15.6 2.2 13.8 2.2 12 2.2 6.6 6.6 2.2 12 2.2S21.8 6.6 21.8 12 17.4 21.8 12 21.8zM12 0C5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6c1.8 1 3.8 1.5 5.8 1.5 6.6 0 12-5.4 12-12S18.6 0 12 0z" />
  </svg>
);

const btn = "inline-flex h-11 items-center gap-2 rounded-full border border-white/20 px-4 text-xs text-[#F7F5F0] transition-colors duration-300 hover:border-[#D98A52] hover:text-[#D98A52]";

export const ShareProject = ({ p, t }) => {
  const url = `${window.location.origin}/?progetto=${p.id}#progetti`;
  const title = t(`proj.${p.id}`, p.title);
  const shareText = `${t("share.text", "Guarda questo progetto di Emma Industrie:")} ${title}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${url}`)}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("share.copied", "Link copiato"));
    } catch {
      toast.error(url);
    }
  };
  return (
    <div className="mt-8 border-t border-white/10 pt-6" data-testid="project-share">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#F7F5F0]/70">{t("share.label", "Condividi")}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <a href={wa} target="_blank" rel="noopener noreferrer" className={btn} data-testid="project-share-whatsapp"><WhatsAppIcon /> WhatsApp</a>
        <SocialShare url={url} text={shareText} t={t} btn={btn} id="project" />
        <button type="button" onClick={copy} className={btn} data-testid="project-share-copy"><Link2 className="h-4 w-4" /> {t("share.copy", "Copia link")}</button>
      </div>
    </div>
  );
};
